module.exports = __webpack_public_path__ + "d96d63b3c9b11f623aa39ea2f9738280.svg";